import React from 'react';
import { TextField, Stack } from '@mui/material';

interface AmountRangeFieldProps {
  minAmount: number;
  maxAmount: number;
  onMinAmountChange: (value: number) => void;
  onMaxAmountChange: (value: number) => void;
  disabled?: boolean;
}

export const AmountRangeField: React.FC<AmountRangeFieldProps> = ({
  minAmount,
  maxAmount,
  onMinAmountChange,
  onMaxAmountChange,
  disabled = false,
}) => {
  const handleMinAmountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value === '' ? 0 : Number(e.target.value);
    if (value >= 0) {
      onMinAmountChange(value);
    }
  };

  const handleMaxAmountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value === '' ? 0 : Number(e.target.value);
    if (value >= 0) {
      onMaxAmountChange(value);
    }
  };

  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }).format(amount);
  };

  return (
    <Stack direction="row" spacing={2}>
      <TextField
        label="Minimum Amount"
        type="number"
        value={minAmount || ''}
        placeholder="0"
        onChange={handleMinAmountChange}
        inputProps={{ min: 0, step: 0.01 }}
        disabled={disabled}
        fullWidth
        helperText={minAmount > 0 ? formatCurrency(minAmount) : undefined}
      />
      <TextField
        label="Maximum Amount"
        type="number"
        value={maxAmount || ''}
        placeholder="0"
        onChange={handleMaxAmountChange}
        inputProps={{ min: 0, step: 0.01 }}
        disabled={disabled}
        fullWidth
        helperText={maxAmount > 0 ? formatCurrency(maxAmount) : undefined}
        error={maxAmount > 0 && maxAmount < minAmount}
      />
    </Stack>
  );
};
